import Vue from 'vue'

const MODULES = {
  source: 'modules',
  route: 'unterrichtsmaterial',
  slugToFilter: { id: 'topic', listId: 'topics' },
  filterTypes: [
    { name: 'Themenbereich', all: 'Alle Themenbereiche', id: 'topic', listId: 'topics' },
    { name: 'Stufe', all: 'Alle Stufen', id: 'grade', listId: 'grades' },
    { name: 'Bundesland', all: 'Alle Bundesländer', id: 'state', listId: 'states' },
    { name: 'Format', all: 'Alle Formate', id: 'type', listId: 'formats' }
  ],
  showOrdering: true,
  showSearch: true,
  description: 'Wenn Sie kostenfreie Materialien für Ihren Wirtschaftsunterricht in der gymnasialen Oberstufe suchen, sind Sie hier genau richtig.',
  errorMessage: 'Leider können die SimGame zurzeit nicht geladen werden. Bitte versuchen Sie es später erneut.'
}

const EVENTS = {
  source: 'events',
  route: 'veranstaltungen',
  slugToFilter: { id: 'sim_games', listId: 'sim_games' },
  filterTypes: [
    { name: 'Planspiel', all: 'Alle Planspiele', id: 'sim_games', listId: 'sim_games' },
    { name: 'Art', all: 'Alle Arten', id: 'event_type', listId: 'event_types' },
    { name: 'Bundesland', all: 'Alle Bundesländer', id: 'state', listId: 'states' },
    { name: 'Monat', all: 'Alle Monate', id: 'month', listId: 'months' },
    { name: 'Jahr', all: 'Alle Jahre', id: 'year', listId: 'years' }
  ],
  showOrdering: false,
  showSearch: false,
  description: 'Wenn Sie an einer Schulung für die Planspiele von Teach Economy teilnehmen und Spielleiter werden möchten, sind Sie hier genau richtig.',
  errorMessage: 'Leider können die Veranstaltungen zurzeit nicht geladen werden. Bitte versuchen Sie es später erneut.'
}

// filterTypes:
//   The "id" is used internaly and for the query parameter in the requests.
//   The "listId" is the key with whitch the filter api point answers.
//   The other fields are labels
// showOrdering:
//   If the ordering Options schould be available to the user.

export default () => {
  const source = Vue.prototype.$source
  if (source === 'modules') {
    return MODULES
  } else if (source === 'events') {
    return EVENTS
  }
  return MODULES
}
